var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_setup.props.groupType === 'job_posting')?_c('div',{staticClass:"job-tag",on:{"click":function($event){return _setup.goToParent()}}},[_c(_setup.Link,{attrs:{"width":"20","height":"20"}}),_vm._v(" Job listing: "+_vm._s(_setup.props.roleName)+" ")],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }